import React from 'react';
import styled from 'styled-components';
import { MobileWidth, pmWhite } from '../sharedData/Constants';

const DownloadButton = () => {
    return (
      <StyledLink target="_blank" href="https://rebrand.ly/BFPmweb-estudobf2024" >
        BAIXAR AGORA
      </StyledLink>
    );
}

const StyledLink = styled.a`
  margin: 24px 0 60px;
  width: 333px;
  height: 50px;
  background-color: ${pmWhite};
  color: rgba(93, 18, 71, 1);
  border-radius: 25px;
  cursor: pointer;
  font-size: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  @media screen and (max-width: ${MobileWidth}){
      width: 302px;
    }
`;

export default DownloadButton;